<template>
  <Card style="width:100%;overflow-x: hidden;margin-top: 10px">
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <router-link :to="{ path: '/admin/stored/batch/index' }">
          <Button icon="ios-arrow-back" size="small" class="mr20">返回</Button>
        </router-link>
        <span class="ivu-page-header-title mr20" v-text="$route.params.id >0 ? '编辑'+this.title : '添加'+this.title"></span>
      </div>
    </div>
    <div class="myModal">
      <Form ref="artInfo"  :model='artInfo' label-position="right" :label-width="100" :rules="ruleValidate" @submit.native.prevent>

        <form-item label="批次名称" prop="title">
          <Input placeholder="请输入" v-model="artInfo.title"></Input>
        </form-item>

        <form-item label="生成数量" prop="phone">
          <Input placeholder="请输入" v-model="artInfo.num" type="number"></Input>
        </form-item>
        <form-item label="制作状态" v-if="status1 === '1'" >
          <RadioGroup v-model="artInfo.status">
            <Radio label='0' >待制作</Radio>
            <Radio label='1' >制作中</Radio>
            <Radio label='2' >制作完成</Radio>
          </RadioGroup>
        </form-item>
      </Form>
    </div>
    <div slot="footer">
      <Button type="primary"   @click="handleOk('artInfo')">确定</Button>
    </div>
  </div>
  </Card>
</template>
<style>
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }



</style>
<script>
  import { Info, edit } from '@/api/storedBatch'
  import ueditor from '@/components/ueditorFrom/index'
  import Setting from '@/setting'
  export default {
    name: 'listEdit',
    components: { ueditor },
    props: ['editShow', 'id'],
    data () {
      return {
        server_url: Setting.serverSrc,
        serverApiPic: Setting.serverApiPic,
        serverApiFile: Setting.serverApiFile,
        uploadList: [], // logo
        visible: false,
        cate_list: [],
        imgUrl: '',
        title: '储值卡',
        editor: null,
        status1: '0',
        status: '0',
        isShow: false,
        article_id: 0,
        artInfo: {
          id: 0,
          title: '',
          num: '',
          status:'0'

        },

        ruleValidate: {
          title: [
            { required: true, message: '请输入批次名称', trigger: 'blur' }
          ]
        }
      }
    },
    created () {
      this.artInfo.id = 0
      this.artInfo.title = ''

    if (this.$route.params.id){
      this.status1 = '1'
    }
      this.articleInfo()
      // this.getCateList()
    },
    methods: {

      handle (status) {
        this.$emit('updateStatusModel', false)
      },
      handleOk (name) {
        // this.artInfo.title = this.$refs.ueDetail.contents
        let data = this.artInfo;
        this.$refs[name].validate(valid => {
          if (valid) {
            edit(data).then(res => {
              let msg = '添加成功'
              if (data.id > 0) {
                msg = '编辑成功'
              }
              if (res.code === 200) {
                this.$Message.success(msg)
                this.$router.push({ path: '/admin/stored/batch/index' })
              } else {

              }
            }).catch(res => {
              this.$Message.error(res.msg)
            })
          }
        })
      },
      articleInfo () {
        if (this.$route.params.id) {
          let data = { 'id': this.$route.params.id }
          Info(data).then(res => {
            // console.log(res)
            this.artInfo = res.data


          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      },
      handleView (url) {
        this.imgUrl = url
        this.artInfo.pic = url
        this.visible = true
      },
      // logo删除
      handleRemove (file) {
        const fileList2 = this.uploadList
        this.delpics.push(file.url)
        this.uploadList.splice(fileList2.indexOf(file), 1)
        this.uploadList = []
      },
      handleAdd () {
        this.index++;

        this.formDynamic.items.push({
          value: '',
          id: 0,
          index: this.index,
          status: 1
        });
      },
      handleRemove1 (index) {
        console.log(index)
        this.formDynamic.items[index].status = 0;
      },
      // logo
      handleSuccess (res, file) {
        file.url = res.data.file_url
        this.uploadList = this.$refs.uploadThumb.fileList
      },
      handleFormatError (file) {
        this.$Message.error('文件' + file.name + '格式错误，请上传jpg或者png')
      },
      handleMaxSize (file) {
        this.$Message.error('文件' + file.name + '太大，不能大于10M')
      },
      // 缩略图
      handleBeforeUpload () {
        const check = this.uploadList.length < 1
        if (!check) {
          this.$Message.error('只能上传1张图片')
        }
        return check
      },

    }
  }
</script>
